import React, { useMemo } from 'react';
import { useParams } from 'umi';
import Abnormal from '@home/components/Abnormal';
import { Card } from 'tea-component';
import MetricDetailCard from '../MetricDetailCard';
import './index.scss';
import { metricValueFormatter } from '@/pages/benchmark/utils/utils';

const MetricDetailCardContext = (props: any) => {
  const { config, style, filterError, metricGroupList } = props ?? {};
  const { metric } = useParams<{ metric: string; }>();
  const { metricData, metricConfig } = props?.data ?? {};
  const { subTitleKey, rightTextKey, contentsTitles, chartConfig } = config ?? {};

  const data = useMemo(() => {
    const rawComponentData = metricData?.data?.[metric] ?? {};
    const metricConfigData = metricConfig?.[metric] ?? {};
    
    // 解构 text_value_json 并合并到 componentData
    const { text_value_json, ...restData } = rawComponentData;
    const componentData = {
      ...restData,
      ...(text_value_json || {}),
    };
    
    // 记录从 text_value_json 解构出来的 keys，这些 key 不需要格式化
    const textValueKeys = text_value_json ? Object.keys(text_value_json) : [];
    
    return {
      componentData,
      metricConfigData,
      textValueKeys,
      loading: metricData?.loading || false,
      errorMsg: metricData?.errorMsg || "",
      errorType: metricData?.errorType || "",
    };
  }, [metricData, metric, metricConfig]);

  const { componentData, metricConfigData, textValueKeys } = data || {};
  const subTitleValue = componentData?.[subTitleKey] ?? '';
  const rightTextValue = componentData?.[rightTextKey] ?? '';
  const {
    nameCn,
    nameEn,
    metric_cn: metricCN,
    metric_en: metricEN,
    tooltipEn,
    tooltipCn,
    otdrValueTipEn,
    otdrValueTipCn,
    value_type: valueType,
    sources
  } = metricConfigData || {};

  // 拆分value_Type转换成组数
  const valueTypeArray = valueType?.trim().split(',').map((item: string) => item.trim()) ?? [];
  // 根据value_type显示指标
  const filteredContentsTitles = contentsTitles?.filter((item: { value: string; }) => valueTypeArray.includes(item?.value)) ?? [];
  const contents = filteredContentsTitles.map((item: { dataKey: string; }) => {
    const value = componentData?.[item.dataKey];
    // otdr值直接返回原始数据
    if (item.dataKey === 'otdr') {
      return value;
    }
    // 从 text_value_json 解构出来的字段直接返回原始数据，不需要格式化
    if (textValueKeys?.includes(item.dataKey)) {
      return value;
    }
    return metricValueFormatter(value, metricConfigData);
  }) ?? [];
  
  //   // 数据源
  // const dataSource = source?.trim().split(',').map((sourceItem: string) => {
  //   const formattedSource = sourceItem.trim().toLowerCase();
  //   return formattedSource === 'steam' ? 'steamblack' : formattedSource;
  // });

  return (
    <Card className="dbb-metric-card-container" style={style}>
      <Abnormal
        isLoading={data?.loading}
        isError={filterError || !!data?.errorMsg}
        style={{ height: '186px' }}
        component={
          <MetricDetailCard
            config={config}
            contents={contents}
            subTitleKey={{ [subTitleKey]: subTitleValue }}
            rightTextKey={{ [rightTextKey]: rightTextValue }}
            titleCn={nameCn || metricCN || metric}
            titleEn={nameEn || metricEN || metric}
            tooltipEn={tooltipEn}
            tooltipCn={tooltipCn}
            valueTipEn={otdrValueTipEn}
            valueTipCn={otdrValueTipCn}
            contentsTitles={filteredContentsTitles}
            dataSources={sources}
            explainInfo={metricConfig}
            metricGroupList={metricGroupList}
            metricData={metricData}
            chartConfig={chartConfig}
          />
        }
      />
    </Card>
  );
};

export default MetricDetailCardContext;
